import React from "react";
import Login from "./pages/Login/Login";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./helpers/ProtectedRoute";
import {
  adminPathLocations,
  pathLocations,
  PlayerPathLocations,
} from "./utils/pathLocations";
import ForgetPassword from "./pages/Login/ForgetPassword";
import ChangePassword from "./pages/Login/ChangePassword";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { isLoggedIn } from "./utils/Auth";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getUserDetails, getUserRole } from "./redux/actions/user-action";
import AdminRoute from "./helpers/AdminRoute";
import { useState } from "react";
import Loading from "./components/Loading";
import DrawerMenu from "./components/Drawer";

function App() {
  const userLogin = isLoggedIn();

  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state?.userDetailsReducer?.data);
  const userRole = useSelector((state) => state.userDetailsReducer?.role);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (userLogin) {
      dispatch(getUserDetails());
    }
  }, []);

  useEffect(() => {
    if (userInfo !== undefined) {
      dispatch(getUserRole(userInfo));
    }
  }, [userInfo]);

  useEffect(() => {
    setTimeout(() => setLoading(false), 3000);
  }, []);

  const routeComponents =
    userRole === "super"
      ? pathLocations.map(({ path, exact, component }, key) => (
          <Route
            exact={exact}
            path={path}
            element={<ProtectedRoute component={component} />}
            key={key}
          />
        ))
      : userRole === "admin"
      ? adminPathLocations.map(({ path, exact, component }, key) => (
          <Route
            exact={exact}
            path={path}
            element={<AdminRoute component={component} />}
            key={key}
          />
        ))
      : PlayerPathLocations.map(({ path, exact, component }, key) => (
          <Route
            exact={exact}
            path={path}
            element={<ProtectedRoute component={component} />}
            key={key}
          />
        ));

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        limit={1}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="light"
      />
      <DrawerMenu />
      {loading ? (
        <Loading />
      ) : (
        // <Router>
        <Routes>
          {/* <AuthInterceptor> */}
          <Route path="/login" exact element={<Login />} />
          <Route path="/forgetPassword" exact element={<ForgetPassword />} />
          <Route
            path="/account/password/reset/:id"
            element={<ChangePassword />}
          />
          {routeComponents}
        </Routes>
        // </Router>
      )}
    </>
  );
}

export default App;
